var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;
export { durationDay, durationHour, durationMinute, durationSecond, durationWeek };
//# sourceMappingURL=duration.js.map
